import { ref } from "vue";

/**
 * Composable for "Don't ask again" confirmation dialogs.
 * Stores preference in a cookie.
 *
 * @param {string} cookieName - Cookie name to store preference
 */
export function useSkipConfirm(cookieName) {
  const showConfirm = ref(false);

  function escapeRegExp(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function getCookie(name) {
    const escaped = escapeRegExp(name);
    const match = document.cookie.match(new RegExp(`(^| )${escaped}=([^;]+)`));
    return match ? match[2] : null;
  }

  function setCookie(name, value, hours = 1) {
    const expires = new Date(Date.now() + hours * 36e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  }

  function maybeConfirm(onSkip) {
    if (getCookie(cookieName) === "true") {
      onSkip();
    } else {
      showConfirm.value = true;
    }
  }

  function setSkipForever() {
    setCookie(cookieName, "true");
  }

  return { showConfirm, maybeConfirm, setSkipForever };
}
